(ns frontend.ux-overhaul.listing.transaction-process.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.ux-overhaul.listing.transaction-process.event :as tp-event]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [ui.view.transaction-process.create-modal :as create-modal]))

(def listing-id "transaction-process-listing")

(defn- open-transaction-process!
  [value]
  (when-let [entity-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       entity-id
                          :entity/type :entity.type/transaction-process})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id           listing-id
         :entity-type          :entity.type/transaction-process
         :pipeline-id          nil
         :filters              {:enabled? true
                                :view-id :transaction-process
                                :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes #{:grid :kanban :gallery :list}
         :toolbar-actions      [{:id       :create-transaction-process
                                 :label    (loc/tr :transaction-process/create)
                                 :visible? (or (session/is-admin?)
                                               (seq (create-modal/fund-options)))
                                 :enabled? true
                                 :event    [::tp-event/open-create-transaction-process-modal]}
                                {:id                  :bulk-delete-transaction-processes
                                 :label               (loc/tr :confirm-delete-selected-button)
                                 :visible?            true
                                 :enabled?            true
                                 :requires-selection? true
                                 :variant             :danger
                                 :event               [::tp-event/bulk-delete-selected {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      [:<>
       (when @tp-event/create-modal-open?
         [create-modal/view {:on-close tp-event/close-create-modal!}])
       [listing/view
        {:listing-id               listing-id
         :title                    (loc/tr :transaction-processes)
         :show-view-mode-selector? true
         :query-placeholder        (loc/tr :listing.transaction-process/search-placeholder)
         :on-create-first-item     #(rf/dispatch [::tp-event/open-create-transaction-process-modal])
         :on-row-clicked           open-transaction-process!
         :on-card-clicked          open-transaction-process!}]])}))
